module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0049.jpg?v=dcc28b81";